/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";

/** Common Components */
import FormCreator from "../../../../../../components/finalForms/FormCreator";
import ToastService from "../../../../../../services/toastService/ToastService";
import { InputText } from "primereact/inputtext";
import MolGrid, { Column } from "@moltech/molui/molgrid";

/** Configuration files */
import { reportCardConfig } from "./ReportCard.formfield.config";

/** RTK Query */
import { useLazyGetContractExpenseBreakdownQuery, useLazyGetContractReportCardDetailsQuery } from "../../../../../../app/services/reportCardAPI";

const ReportCard = (props) => {
    const inputRefs = useRef({});
    const activeInputRef = useRef({});
    const cellRefs = useRef({});
    const url = window.location.search;
    const plContractKey = new URLSearchParams(url).get("contract");
    const [cardData, setCardData] = useState(reportCardConfig);
    const ReportCardRef = useRef();
    const [gridData, setGridData] = useState([]);
    const [data, setData] = useState(null);
    const [copied, setCopied] = useState(false);
    const editableFields = ['expenseCategory', "expense"];

    const [getContractReportCardDetails, {
        isFetching: isGetContractReportCardDetailsFetching,
        isSuccess: isGetContractReportCardDetailsFetched,
        data: getContractReportCardDetailsData,
    }] = useLazyGetContractReportCardDetailsQuery();

    const [getContractExpenseBreakdown, {
        isFetching: isGetContractExpenseBreakdownFetching,
        isSuccess: isGetContractExpenseBreakdownFetched,
        data: getContractExpenseBreakdownData,
    }] = useLazyGetContractExpenseBreakdownQuery();

    useEffect(() => {
        getContractReportCardDetails(plContractKey);
        getContractExpenseBreakdown(plContractKey);
    }, [plContractKey]);

    useEffect(() => {
        if (isGetContractReportCardDetailsFetched && getContractReportCardDetailsData) {
            let formData = { ...cardData };
            formData.initialState = {
                contractAmount: getContractReportCardDetailsData[0]?.contractAmount || "0",
                consumptionTotal: getContractReportCardDetailsData[0]?.consumptionTotal || "0",
                expenseAmount: getContractReportCardDetailsData[0]?.expenseAmount || "0",
                contractBasedonExpenses: getContractReportCardDetailsData[0]?.contractBasedonExpenses,
                marginPercentage: getContractReportCardDetailsData[0]?.marginPercentage || "0",
                efficiencyRating: getContractReportCardDetailsData[0]?.efficiencyRating || "0",
                percentValueConsumedExpenses: getContractReportCardDetailsData[0]?.percentValueConsumedExpenses || "0",
                percentTimeElapsed: getContractReportCardDetailsData[0]?.percentTimeElapsed || "0",
                contractIndexExpenses: getContractReportCardDetailsData[0]?.contractIndexExpenses || "0",
                percentValueConsumedConsumption: getContractReportCardDetailsData[0]?.percentValueConsumedConsumption || "0",
                contractIndexConsumption: getContractReportCardDetailsData[0]?.contractIndexConsumption || "0",
                revenueTotal: getContractReportCardDetailsData[0]?.revenueTotal || "0",
                expenseTotal: getContractReportCardDetailsData[0]?.expenseTotal || "0",
            }
            setCardData(formData);
        }
    }, [
        isGetContractReportCardDetailsFetched,
        getContractReportCardDetailsData
    ]);

    useEffect(() => {
        if (isGetContractExpenseBreakdownFetched && getContractExpenseBreakdownData) {
            setGridData(getContractExpenseBreakdownData);
            setData(getContractExpenseBreakdownData);
        }
    }, [isGetContractExpenseBreakdownFetched, getContractExpenseBreakdownData]);

    const handleCopy = (row) => {
        const textToCopy = row.expenseCategory || row.expense;
        // navigator.clipboard.writeText(textToCopy);

        ToastService.info(`Copied: ${textToCopy}`);
        setCopied(true);
        setTimeout(() => setCopied(false), 800);
    };

    const cellRenderer = (rowData, options) => {
        const { rowIndex, field } = options;
        const key = `${rowIndex}-${field}`;
        return (
            <span
                ref={(el) => (cellRefs.current[key] = el)}
                style={{ cursor: 'pointer', display: 'block', width: '100%' }}
            >
                {rowData[field] ?? ''}
            </span>
        );
    };

    const onCellEditComplete = (e) => {
        const { rowData, newValue, field, rowIndex, value, newRowData } = e;

        let changeValue = value == null ? "" : value
        if ((newValue != null && newValue != changeValue) && (newValue != value)) {
        }
    };

    const handleFieldEditor = (options) => {
        const { rowIndex, field, value, editorCallback } = options;
        const key = `${rowIndex}-${field}`;

        // Validate editableFields and field
        if (!Array.isArray(editableFields) || !editableFields.includes(field)) {
            return <>{options?.value ?? ''}</>;
        }

        return (
            <InputText
                ref={(el) => {
                    inputRefs.current[key] = el;
                    if (el) {
                        activeInputRef.current = el;
                        setTimeout(() => el.focus(), 0);
                    }
                }}
                type="text"
                value={value ?? ''}
                // onChange={(e) => editorCallback(e.target.value)}
                onChange={(e) => {
                    try {
                        editorCallback(e.target.value); // Update value via editorCallback
                    } catch (error) {
                        console.error('Error updating value:', error);
                    }
                }}
            />
        );
    };

    const getCtxMenuItems = (row) => {
        if (!row) return [];
        return [
            {
                label: "Copy",
                command: () => handleCopy(row)
            },
            {
                label: 'Paste',
                command: () => { }
            },
            {
                label: 'Edit',
                command: () => { }
            },
            {
                label: 'Clear Value',
                command: () => { }
            }
        ];
    }

    return (
        <>
            <div className="client-section task-tab-sec">
                <div className="new-client-sec">
                    <div className="row align-items-center inventory-checkboxes">
                        <FormCreator
                            config={cardData}
                            ref={ReportCardRef}
                        />
                    </div>
                    <div className='mt-3'>
                        <MolGrid
                            value={gridData}
                            sortMode="single"
                            showGridlines
                            resizableColumns
                            scrollable
                            scrollHeight="flex"
                            paginator={false}
                            metaKeySelection={true}
                            ctxMenuItems={getCtxMenuItems}
                            editMode="cell"
                        >
                            <Column
                                field="expenseCategory"
                                header="Category"
                                sortable
                                bodyStyle={{ textAlign: "center" }}
                                editor={handleFieldEditor}
                                style={{ width: '20%' }}
                                body={cellRenderer}
                                onCellEditComplete={onCellEditComplete}
                            />
                            <Column
                                field="expense"
                                header="Expense"
                                sortable
                                bodyStyle={{ textAlign: "center" }}
                                editor={handleFieldEditor}
                                style={{ width: '20%' }}
                                body={cellRenderer}
                                onCellEditComplete={onCellEditComplete}
                            />
                        </MolGrid>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ReportCard;